// extracted by mini-css-extract-plugin
export default {"theme_modal":"ForgotPasswordModal_theme_modal__PLmY8","profile_img":"ForgotPasswordModal_profile_img__DQe3X","member_designation":"ForgotPasswordModal_member_designation__yFzXg"};